import { servicelinkFloodApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SERVICELINK_FLOOD_PRODUCTS_ACTION_TYPE = createNamedActions(
  'servicelinkFloodProducts',
  {
    GET_SERVICELINK_FLOOD_PRODUCTS: 'GET_SERVICELINK_FLOOD_PRODUCTS',
  },
);

export const loadServicelinkFloodProductsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await servicelinkFloodApi.getProducts();

  return dispatch({
    type: SERVICELINK_FLOOD_PRODUCTS_ACTION_TYPE.GET_SERVICELINK_FLOOD_PRODUCTS,
    payload: data,
  });
});
